const formatDateWithoutTimeZone = (date, options = {
  month: 'long',
  year: 'numeric',
  day: 'numeric'
}) => {
  if (!date) return undefined;
  return new Date(new Date(date).toISOString().slice(0, -1)).toLocaleDateString(undefined, options);
};
const formatDateWithTimeZone = (date, options = {
  month: 'long',
  year: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: '2-digit'
}) => {
  if (!date) return undefined;
  return new Date(new Date(date).toISOString().slice(0, -1)).toLocaleDateString(undefined, options);
};
export { formatDateWithTimeZone, formatDateWithoutTimeZone };
//# sourceMappingURL=formatDateWithoutTimeZone.js.map
